import { useState } from 'react';
import { Link, Navigate, useNavigate } from 'react-router-dom';
import { useAuth, useLogin } from '../hooks/queries';
import { ApiError } from '../lib/api';
import { Button, Field, Input, ErrorNote } from '../components/ui';
import { AuthShell } from './AuthShell';

export function Login() {
  const { user } = useAuth();
  const login = useLogin();
  const nav = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  if (user) return <Navigate to="/dashboard" replace />;

  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    login.mutate({ email, password }, { onSuccess: () => nav('/dashboard') });
  };

  return (
    <AuthShell title="Welcome back" subtitle="Sign in to your VentureWrist account">
      <form onSubmit={submit} className="space-y-4">
        <Field label="Email">
          <Input type="email" autoComplete="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
        </Field>
        <Field label="Password">
          <Input type="password" autoComplete="current-password" required value={password} onChange={(e) => setPassword(e.target.value)} />
        </Field>
        <ErrorNote>{login.error ? (login.error as ApiError).message : null}</ErrorNote>
        <Button type="submit" className="w-full" disabled={login.isPending}>
          {login.isPending ? 'Signing in…' : 'Sign in'}
        </Button>
      </form>
      <p className="mt-4 text-center text-sm text-mut">
        No account? <Link to="/signup" className="text-acc hover:underline">Create one</Link>
      </p>
    </AuthShell>
  );
}
